import { action, computed, makeAutoObservable } from 'mobx';

import { EpisodeExtended, ProgressBar } from '@smart-tv/components/program-sheet/types';

import { RootStore } from './store-root';

export type ProviderPickerVersionType = EpisodeExtended['providers'][0]['versions'][0] & {
  providerName: string;
  providerLogo?: string;
  length: number;
  airTime: number;
  forceStartOver?: boolean;
};
class ProviderVersionStore {
  providersData = [] as EpisodeExtended['providers'];
  rootStore: RootStore;

  constructor(root: RootStore) {
    this.rootStore = root;
    makeAutoObservable(this, {
      setProvidersData: action,
      providersVersionsPickerModel: computed
    });
  }

  setProvidersData(providers: EpisodeExtended['providers']) {
    this.providersData = providers;
  }

  get providersVersionsPickerModel() {
    const pickerDataModel = [] as ProviderPickerVersionType[];

    if (!this.providersData || this.providersData.length === 0) {
      return pickerDataModel;
    }

    this.providersData.forEach((provider) => {
      provider.versions.forEach((ver) => {
        const airTime = ver.airTimeStart ? new Date(ver.airTimeStart * 1000).getTime() : 0;
        pickerDataModel.push({
          ...ver,
          providerName: provider.providerName,
          providerLogo: provider.covers.current,
          length: provider.length,
          airTime: airTime,
          forceStartOver: provider.lastWatched?.progressBar === ProgressBar.FULL
        });
      });
    });

    return pickerDataModel;
  }
}

export default ProviderVersionStore;
